import { ApiResponse } from "../types/api/apiresponse.types";
import { Gameboard } from "../types/gameboard/gameboard.types";
import { abstractApiCaller } from "./apiCaller";

class GameBoardApi extends abstractApiCaller
{
    public async getNewBoard (size: number)
    {
        const endpoint = '/getNewBoard/' + size;

        const param = {
        };

        return await this.query<ApiResponse<Gameboard>>(endpoint, param, 'GET');
    }
}

export { GameBoardApi };
